/**
 * The one LOD level constant the per-type specs and the registry both need.
 *
 * Its own module because the specs (types/*.ts) name it and the registry imports the
 * specs: with it living in the registry, reading it at spec-construction time is a read of a
 * half-initialised module.
 */
/**
 * Coarsest LOD that places stamps INDIVIDUALLY. Above it the same picture is drawn per COLUMN.
 *
 * Not a visual choice — a measured one, on two curves that cross here. Placement walks the coarse
 * footprint as fine chunks (it must: the scatter's spacing rules are chunk-local), so its cost
 * quadruples per level: 5.2 ms per column at lod 5, 17.8 at lod 6, 66.6 at lod 7, and ~1.1 s at
 * lod 9 — which is reachable (MAX_BASE_LOD 3 + 6 far levels) and would stall the ring streamer.
 * Meanwhile the dots SATURATE: distinct coarse columns touched by a tree run 62% of the chunk at
 * lod 4, 93% at lod 5, then >100% at lod 6 and 7 (the footprint's margin ring pushes it over).
 * So from lod 6 every eligible column already gets a dot, and asking WHICH tree put it there costs
 * 1000x more for the same pixels.
 */
export const MAX_SCATTER_LOD = 5;
/**
 * Coarsest LOD at which a building still carries its exterior LAMPS (see coarseModel.lampPart) — all the
 * way to the scatter cutoff, because a point of light is the last thing about a village worth drawing.
 *
 * A lamp must be one full coarse voxel to emit at all, so its size goes with the stride: 1 m at lod 1,
 * 2 m at lod 2, 4 m at lod 3. From lod 4 the whole building is a one-voxel pin, so the lamp becomes one
 * voxel BESIDE it rather than a blob standing off a wall it no longer has — a village at 640 m to 1.3 km
 * reads as a cluster of lights for one voxel each. The light retires on its own curve: its per-voxel
 * falloff doubles per level to hold the world radius fixed, so at lod 5 a single step exhausts it and
 * the lamp is a bright point with no spill.
 */
export const MAX_LAMP_LOD = MAX_SCATTER_LOD;
/**
 * Coarsest LOD at which a building is drawn by FOLDING its LOD-0 model (see voxel/fold.ts) rather than by
 * a stand-in. One, and the number is the voxel size: a lod-1 voxel is 0.5 m and LOD 0's walls are
 * already 0.5 m thick, so the real model transfers with its hollow interior, its carved doors and
 * windows and its crenellations intact. At lod 2 a 1.5 m window is a single cell and the same fold
 * costs the same ~95k fine samples for a picture the authored parts already give.
 */
export const MAX_FOLD_LOD = 1;
//# sourceMappingURL=lodLevels.js.map